/**
 * Acceso perezoso al cliente de backend.
 *
 * El cliente arrastra ~97 KB (auth, storage, realtime) que la portada anónima
 * no necesita para pintar. Importándolo de forma dinámica sale del chunk de
 * entrada y deja de competir con el primer pintado en móvil.
 */
type SupabaseClient = typeof import("@/integrations/supabase/client")["supabase"];

let cached: Promise<SupabaseClient> | undefined;

export function getSupabase(): Promise<SupabaseClient> {
  if (!cached) {
    cached = import("@/integrations/supabase/client").then((m) => m.supabase);
  }
  return cached;
}
